import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Your password has been reset!");
      nav("/login");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="reset-page">
      <div className="w-full max-w-md glass rounded-2xl p-8">
        <div className="flex justify-center mb-6"><Logo className="h-12" showText /></div>
        <h1 className="font-display text-2xl font-bold text-white text-center">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-rose-400 text-center mt-6">Invalid or expired link.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-slate-300">New password</Label>
              <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input"
                className="bg-surface-2 border-white/10 text-white mt-1" />
            </div>
            {error && <p className="text-sm text-rose-400">{error}</p>}
            <Button type="submit" className="w-full btn-gold h-11" disabled={loading} data-testid="reset-submit-button">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Reset password
            </Button>
          </form>
        )}
        <p className="text-sm text-slate-400 text-center mt-6">
          <Link to="/login" className="text-gold hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
